import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToHomePage } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";

type ParameterProps = {
    redirectUrl?: string;
};
type HandlerType = Handler<ParameterProps>;

export const RedirectToHomePageExtension: HandlerType = props => {
    const state = props.getState();
    if (props.parameter.redirectUrl) {
        window.location.href = props.parameter.redirectUrl;
    } else {
        window.location.href = getHomePageUrl(state);
    }
};

replaceInChain(chain, RedirectToHomePage, RedirectToHomePageExtension);
